import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawRecDataList, RawSmpDataList } from '../types/kpx';
import type { RequestOptions } from '../types/common';

export function createKpxApi(http: Http) {
  return {
    async getRecData(
      latest?: number,
      start?: string,
      end?: string,
      options?: RequestOptions,
    ): Promise<RawRecDataList> {
      const res = await http.get<RawRecDataList>(endpoints.kpx.rec(start, end), {
        params: latest !== undefined ? { latest } : undefined,
        signal: options?.signal,
      });
      return res.data;
    },

    async getSmpData(
      area?: string,
      latest?: number,
      start?: string,
      end?: string,
      options?: RequestOptions,
    ): Promise<RawSmpDataList> {
      const params: Record<string, string | number> = {};
      if (area !== undefined) params['area'] = area;
      if (latest !== undefined) params['latest'] = latest;
      const res = await http.get<RawSmpDataList>(endpoints.kpx.smp(start, end), {
        params: Object.keys(params).length > 0 ? params : undefined,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
